'use client'
import { Box, Typography } from '@mui/material'
import Link from 'next/link'
import MuiAccordion from '@/UI/MUI/Accordion/Accordion'
import { colors } from '@/Theme/LegacyTheme'
import { ContactVariables } from '@/GlobalVariables/Contact'
import { customerCareFaqItems } from './Content'

const PageContent = () => {
  return (
    <>
      <Typography variant="h1" sx={{ fontSize: { xs: '32px', sm: '50px' }}}>
        Customer Care
      </Typography>
      <Box>
        <Typography variant="body1">
          We&apos;re committed to providing you with the best possible products and services but
          sometimes we know that things go wrong. If you&apos;re not happy or feel the need to make
          a complaint; you can reach us by any of the following ways.
        </Typography>

        <Typography color={colors.darkGreen} sx={{ mb: 0 }}>
          By post:
        </Typography>
        <address style={{ marginBottom: 32, fontStyle: 'normal' }}>
          The Customer Care Manager
          <br />
          Zuto Limited
          <br />
          Winterton House
          <br />
          Winterton Way
          <br />
          Macclesfield
          <br />
          Cheshire
          <br />
          SK11 0LP
        </address>

        <Typography color={colors.darkGreen} sx={{ mb: 0 }}>
          By telephone:
        </Typography>
        <Typography variant="body1" color={colors.lightBlue}>
          <Link href={`tel:${ContactVariables.zutoContactNumber}`} role="link">
            {ContactVariables.zutoContactNumber}
          </Link>
        </Typography>

        <Typography color={colors.darkGreen}  sx={{ mb: 0 }}>
          By email:
        </Typography>
        <Typography variant="body1" sx={{ mb: 7 }}>
          <Link href="mailto:customercare@zuto.com" role="link">
            customercare@zuto.com
          </Link>
        </Typography>

        <Typography color={colors.darkGreen} variant="h3" sx={{ mb: 3 }}>
          Frequently asked questions
        </Typography>
        <Box sx={{ mb: 6 }}>
          <MuiAccordion accordionData={customerCareFaqItems} />
        </Box>
      </Box>
    </>
  )
}

export default PageContent
